import { config } from "../state/config";

/** WOZ values keyed by year (as string), in euros. */
export type WozValues = Record<string, number>;

/**
 * Fetch WOZ values per year for a BAG nummeraanduiding (address `extId`),
 * via the reference service.
 */
async function values(extId: string): Promise<WozValues> {
  const response = await fetch(`${config.referenceUrl}/api/woz/${encodeURIComponent(extId)}`);
  if (!response.ok) throw new Error(`HTTP status ${response.status}`);
  return response.json();
}

export const WozService = { values };
